import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminLsaDiscoveredAccounts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/lsa/discovered_accounts/index.vue')
    createVueApp(IndexPage, { props })
  }
}
